// extracted by mini-css-extract-plugin
module.exports = {"emailAddress":"styles_emailAddress__36jdd","titleContainer":"styles_titleContainer__2FEtB"};